import React from 'react'
import classNames from 'classnames'
import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import s from './day-events.scss'
import {EventInfoProps} from '.'

export const DayEvents = ({events, firstEventTime, t}: EventInfoProps) => {
  const responsiveCells = useExperiments().experiments.enabled(ExperimentNames.CalendarResponsiveCells)

  if (!events.length) {
    return null
  }

  return (
    <div className={classNames(s.info, {[s.responsiveCells]: responsiveCells})}>
      <div className={s.fullEvents}>
        <div className={s.time} data-hook="cell-event-time">
          {firstEventTime}
        </div>
        <div className={s.title}>
          <div className={s.titleContent} data-hook="cell-event-title">
            {events[0].title}
          </div>
        </div>
        {events.length > 1 ? (
          <div className={s.more} data-hook="more-link">
            {t('layout.calendar.monthly.events.moreLink', {amount: events.length - 1})}
          </div>
        ) : null}
      </div>
      <div className={classNames(s.compactEvents, s.more)} data-hook="more-link">
        {t('layout.calendar.monthly.events.moreLink', {amount: events.length})}
      </div>
    </div>
  )
}
